export const FLOATING_EVENT_VISIBILITY_HIDE = 'floating:visibility-hide';
